import type { FormEvent } from 'react';

/**
 * The `onSubmit` of a form whose submit button does a step (app#366), so that Enter — Go on a
 * phone keyboard — in any of its fields does what a tap on the button does.
 *
 * The page stays: a submit left to the browser reloads it, and what was typed goes with it. And
 * nothing runs while `held` — the button's own `disabled`, passed in. A browser does not press a
 * disabled button for Enter (Safari on iOS 27 and Chromium, checked 2026-10-31), but a submit can
 * reach the form without it — `requestSubmit()` from code, a webview that does not hold it back —
 * and then the form must not send an empty field, or a second request while the first is out.
 */
export const submitUnless =
  (held: boolean, action: () => unknown) =>
  (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    if (!held) void action();
  };
